import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import { UnderDevelopment } from 'components/UnderDevelopment/UnderDevelopment';

const useStyles = makeStyles<Theme>((_theme) => ({
  root: {
    width: '100%',
  },
}));

export default function CharBuilder() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          {/* Char Builder content will go here */}
          <UnderDevelopment />
        </GridItem>
      </GridContainer>
    </div>
  );
}
